import { useEffect } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { useMenuStore } from '../../store/menuStore';
import { Menu } from './Menu';
import { SideMenuElement, SideMenuOverlay } from './SideMenuStyle';

export function SideMenu() {
  const isMenuOpened = useMenuStore((state) => state.opened);
  const switchOpen = useMenuStore((state) => state.switchOpen);
  const { authenticated } = useAuthContext();

  useEffect(() => {
    if (isMenuOpened) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpened]);

  return (
    <SideMenuElement isOpened={isMenuOpened}>
      {authenticated && (
        <>
          <Menu />
          <SideMenuOverlay onClick={switchOpen} isOpened={isMenuOpened} />
        </>
      )}
    </SideMenuElement>
  );
}
